import React, { useState } from 'react'
import { Avatar, Button, Popover, Tooltip } from 'antd'
import { AppstoreOutlined } from '@ant-design/icons'
import { modules } from '../../../../mock/dataMock'
import { useTranslation } from '../../../hooks/useTranslation'

const AppSwitcher: React.FC = () => {
  const [open, setOpen] = useState(false)
  const { t } = useTranslation()

  const grid = (
    <div className="gt-product-grid">
      {modules.map((module) => (
        <button
          type="button"
          key={module.id}
          className="gt-product-grid-item"
          onClick={() => setOpen(false)}
        >
          <Avatar style={{ height: 42, width: 42 }} shape="square" src={module.icon} />
          <div className="gt-product-grid-label">
            {t(`navigation.appSwitcherModules.${module.translationKey}`)}
          </div>
        </button>
      ))}
    </div>
  )

  return (
    <Popover
      content={grid}
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      arrow
      placement="bottomRight"
      styles={{ content: { padding: 0 } }}
    >
      <Tooltip title={t('navigation.appSwitcher')} open={open ? false : undefined}>
        <Button
          type="text"
          className="gt-header-icon-btn"
          icon={<AppstoreOutlined />}
          aria-label={t('navigation.appSwitcher')}
        />
      </Tooltip>
    </Popover>
  )
}

export default AppSwitcher
